import React, { useEffect, useRef, useState } from 'react'
import { marked } from 'marked'
import ReactQuill from 'react-quill'
import QuillMarkdown from 'quilljs-markdown'
import TurndownService from 'turndown'
import 'react-quill/dist/quill.snow.css'

type Props = {
    value: string // markdown
    onChange: (markdown: string) => void
    placeholder?: string
}

const turndownService = new TurndownService()

const MarkdownEditor = ({ value, onChange, placeholder, ...props }: Props) => {
    const quillRef = useRef<ReactQuill | null>(null)
    const [content, setContent] = useState('')

    useEffect(() => {
        if (quillRef.current) {
            const editor = quillRef.current.getEditor()
            new QuillMarkdown(editor)
        }
        if (value) {
            setContent(marked(value))
        }
    }, [])

    useEffect(() => {
        if (!value) {
            setContent('')
        }
    }, [value])

    const handleChange = (content: string) => {
        setContent(content)
        const markdown = content ? turndownService.turndown(content) : content
        onChange(markdown)
    }

    return (
        <ReactQuill
            {...props}
            ref={quillRef}
            value={content}
            onChange={handleChange}
            placeholder={placeholder}
            modules={{ toolbar: false }} 
            theme="snow"
        />
    )
}

export default MarkdownEditor
